/* kp-text-anim.js — Globale Typo-Animation für .anim-text
   Nutzung: einfach class="anim-text" setzen (Text bleibt als Fallback sichtbar)
   Optional pro Element steuerbar via:
   data-anim-stagger="55"  (ms je Buchstabe)
   data-anim-dur="860"     (ms Dauer)
   data-anim-y="1.1em"     (Startoffset)
   data-anim-blur="14"     (Startblur)
*/

(function(){
  const SELECTOR = '.anim-text';

  // Split in Grapheme-Cluster (auch Emojis etc.)
  function splitToChars(el){
    if (el.dataset.animReady === '1') return; // idempotent
    const original = el.dataset.text || el.textContent; // data-text bevorzugen, sonst Inhalt
    if (!original) return;

    el.setAttribute('aria-label', original); // Screenreader-Fallback
    el.textContent = ''; // wir bauen neu auf

    const seg = ('Segmenter' in Intl) ? new Intl.Segmenter(document.documentElement.lang || 'de', { granularity: 'grapheme' }) : null;
    const parts = seg ? Array.from(seg.segment(original), s => s.segment) : Array.from(original);

    const frag = document.createDocumentFragment();
    for (const ch of parts){
      if (ch === ' '){
        frag.appendChild(document.createTextNode(' '));
      } else {
        const wrap = document.createElement('span');
        wrap.className = 'charWrap';
        const c = document.createElement('span');
        c.className = 'char';
        c.textContent = ch;
        wrap.appendChild(c);
        frag.appendChild(wrap);
      }
    }
    el.appendChild(frag);
    el.dataset.animReady = '1';
  }

  // Stagger / Delays setzen
  function applyDelays(el, indexInPage){
    const chars = el.querySelectorAll('.char');
    if (!chars.length) return;

    // Globale Defaults aus CSS-Variablen
    const cs = getComputedStyle(document.documentElement);
    const defaultStagger = parseInt(cs.getPropertyValue('--anim-letter-stagger')) || 55;
    const defaultDur     = parseInt(cs.getPropertyValue('--anim-dur')) || 860;

    // Element-spezifische Overrides via data-*
    const stagger = parseInt(el.dataset.animStagger || defaultStagger);
    const dur     = parseInt(el.dataset.animDur || defaultDur);

    // Zusätzlicher Offset pro Element, damit getrennte Blöcke nacheinander starten
    const blockOffset = (parseInt(el.dataset.animBlockOffset || 0) || 0) + (indexInPage * 120);

    chars.forEach((c, i) => {
      c.style.animationDelay = (blockOffset + i * stagger) + 'ms';
      // Dauer override, falls gesetzt
      if (dur) c.style.animationDuration = dur + 'ms';
    });

    // Optional: weitere Overrides (Y / Blur) via data-*
    if (el.dataset.animY)    el.style.setProperty('--anim-y', el.dataset.animY);
    if (el.dataset.animBlur) el.style.setProperty('--anim-blur-start', el.dataset.animBlur + 'px');
  }

  // Sichtbarkeits-Trigger
  const io = ('IntersectionObserver' in window) ? new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      // Delays erst setzen, wenn sichtbar
      applyDelays(el, visibleIndex(el));
      // Start durch Reflow (Keyframes starten durch Delay automatisch)
      io.unobserve(el);
    });
  }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' }) : null;

  function visibleIndex(el){
    // grobe Reihenfolge im Dokument
    const all = Array.from(document.querySelectorAll(SELECTOR));
    return Math.max(0, all.indexOf(el));
  }

  function init(root){
    const scope = root || document;
    const nodes = Array.from(scope.querySelectorAll(SELECTOR));
    nodes.forEach(splitToChars);
    if (io){
      nodes.forEach(n => io.observe(n));
    } else {
      // Fallback ohne IO: sofort starten
      nodes.forEach((n, idx) => applyDelays(n, idx));
    }
  }

  // Initial beim Laden
  document.addEventListener('DOMContentLoaded', () => init());

  // Shopify Theme Editor Events (Sections werden dynamisch geladen)
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => init(e.target));
})();
